module.exports = __webpack_public_path__ + "img/transfer.d50f90bf.png";